"use strict";

exports.__esModule = true;
var _OpenReportActionElement = require("./OpenReportActionElement");
Object.keys(_OpenReportActionElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OpenReportActionElement[key]) return;
  exports[key] = _OpenReportActionElement[key];
});
var _OpenReportActionFields = require("./OpenReportActionFields");
Object.keys(_OpenReportActionFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OpenReportActionFields[key]) return;
  exports[key] = _OpenReportActionFields[key];
});
var _action = require("./action");
Object.keys(_action).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _action[key]) return;
  exports[key] = _action[key];
});